// @ts-nocheck

import { useSelector } from 'react-redux';

import { RootState } from 'src/store/reducers';

import PageLayout from '@components/PageLayout';
import CardContainer from '@components/CardContainer';

import { getLabelFallback } from '@utils/utils';
import { useEffect } from 'react';


const Dashboard = (): JSX.Element => {
    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const isMenuMobileSelected = useSelector((state: RootState) => state.common.isMenuMobileSelected);
    const backLabel = getLabelFallback('BACK_CTA_LABEL');
    const dashboardLabel = getLabelFallback('DASHBOARD_MENU_LABEL');

    const switchForDevice = (value) => {
        switch (value) {
            case 'desktop':
                return 'D';
            case 'mobile':
                return 'M';
            case 'tablet':
                return 'T';
            case 'responsive':
                return 'X';
            case 'ipad':
                return 'iPAD';
            default:
                return value;
        }
    }

    useEffect(() => {
        let obj = {
            id: 'VirtualPage-View',
            Page_Type: 'Static',
            Page_Section1: 'Account',
            Page_Section2: '',
            Page_Brand: window.universalTagData.Page_Brand !== undefined ? window.universalTagData.Page_Brand : '',
            Page_Country: window.universalTagData.Page_Country !== undefined ? window.universalTagData.Page_Country : '',
            Page_Platform: window.universalTagData.Page_Platform !== undefined ? window.universalTagData.Page_Platform : '',
            Page_Language: window.universalTagData.Page_Language !== undefined ? window.universalTagData.Page_Language : '',
            Page_DeviceType: window.universalTagData.Page_DeviceType !== undefined ? switchForDevice(window.universalTagData.Page_DeviceType) : '',
            Page_Server: window.universalTagData.Page_Server,
            User_LoginStatus: window.universalTagData.User_LoginStatus !== undefined ? window.universalTagData.User_LoginStatus : '',
            User_LoginType: window.universalTagData.User_LoginType !== undefined ? window.universalTagData.User_LoginType : '',
            User_Email_MD5: window.universalTagData.User_Email_MD5 !== undefined ? window.universalTagData.User_Email_MD5 : '',
            User_Email_SHA256: window.universalTagData.User_Email_SHA256 !== undefined ? window.universalTagData.User_Email_SHA256 : '',
            User_Phone_MD5: window.universalTagData.User_Phone_MD5 !== undefined ? window.universalTagData.User_Phone_MD5 : '',
            User_Phone_SHA256: window.universalTagData.User_Phone_SHA256 !== undefined ? window.universalTagData.User_Phone_SHA256 : '',
            User_EmailOptin: window.universalTagData.User_EmailOptin !== undefined ? window.universalTagData.User_EmailOptin : '0',
            User_Id: window.universalTagData.User_Id.toString(),
            User_Segments: window.universalTagData.User_Segments !== undefined ? window.universalTagData.User_Segments : '',
            Fs_IsConnected: window.universalTagData.Fs_IsConnected !== undefined ? window.universalTagData.Fs_IsConnected : '',
            Page_UserFace: window.universalTagData.Page_UserFace !== undefined ? window.universalTagData.Page_UserFace : '',
            Page_UserStyle: window.universalTagData.Page_UserStyle !== undefined ? window.universalTagData.Page_UserStyle : '',
        };
        if (window.universalTagData.User_Country !== undefined && window.universalTagData.User_Country !== 'N.A.' && window.universalTagData.User_Country !== 'UNDEFINED') {
            obj.User_Country = window.universalTagData.User_Country;
        }
        window?.tealium_data2track?.push(obj);
    }, [])

    return (
        <PageLayout
            data_element_id="AccountSummary_UserSummary"
            hideMenu
            labelMenu={dashboardLabel}
            backLabel={backLabel}
        >
            {(!isMobile || isMenuMobileSelected) && (
                <div className="dashboard">
                    <CardContainer />
                    {/* <SyncPurchasesForm onSubmitForm={handleSubmitForm} /> */}
                </div>
            )
            }
        </PageLayout>
    );
};

export default Dashboard;
